import type { TriggerSourceAdapter } from './types.js';

/**
 * Trigger source registry — mirrors the FrameworkAdapter self-registration
 * pattern (provisioning/framework-registry.ts). Adapters call
 * registerTriggerSource() at module load.
 */
const sources = new Map<string, TriggerSourceAdapter>();

export function registerTriggerSource(adapter: TriggerSourceAdapter): void {
  sources.set(adapter.provider, adapter);
}

/**
 * Returns undefined for unknown providers (the webhook ingress maps that to a
 * uniform 401 rather than throwing).
 */
export function getTriggerSource(provider: string): TriggerSourceAdapter | undefined {
  return sources.get(provider);
}

export function listTriggerSources(): TriggerSourceAdapter[] {
  return Array.from(sources.values());
}
